import axios from "axios";
import {
    START_TRIAL_REQUEST,
    START_TRIAL_SUCCESS,
    START_TRIAL_FAILURE,
    START_TRIAL_RESET
} from "./TrialTypes";
import { getActiveSpecialty } from "util/specialtyCollections";

const startTrialRequest = () => {
    return {
        type: START_TRIAL_REQUEST,
    }
}

const startTrialSuccess = (data) => {
    return {
        type: START_TRIAL_SUCCESS,
        payload: data
    }
}

const startTrialFailure = (error) => {
    return {
        type: START_TRIAL_FAILURE,
        payload: error
    }
}

export const startTrialReset = () => {
    return {
        type: START_TRIAL_RESET,
    }
}

// Start a free trial for the current user
export const startFreeTrial = () => (dispatch, getState) => {
    dispatch(startTrialRequest());

    axios.post('/startFreeTrial', { specialty: getActiveSpecialty(getState) })
        .then(res => {
            dispatch(startTrialSuccess(res.data));
        })
        .catch(err => {
            dispatch(startTrialFailure(
                err.response?.data?.error || 'Failed to start free trial'
            ));
        });
}
